import {AlertController, NavController, NavParams, Keyboard} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {AgencyUserZbListPage} from "../agencyUserZbList/agencyUserZbList";

//和下级投注样式差不多历史一样
@Component({
    templateUrl: 'agencyUserZbSearch.html',
    selector: 'agency-user-zb-search-page',
})
export class AgencyUserZbSearchPage {
    //账变类型
    typeid: number = -1;
    starttime: any;
    endtime: string;
    //编号
    wid: string;
    //账变编号
    id: string;
    typelist: any = [];

    constructor(private keyboard: Keyboard, private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController, private userService: UserService) {
        this.initService(navParams.get("data")["loginname"]);
    }

    initService(loginname: string) {
        let requestData: any = {
            loginname: loginname
        };

        this.userService.agentUserZbInit(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.typelist = data["typelist"];
                this.starttime = data["starttime"].replace(" ", "T");
                this.endtime = data["endtime"].replace(" ", "T");
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    searchFn() {
        let requestData: any = {
            type: this.typeid,
            wid: this.wid,
            starttime: this.starttime.replace("T", ' ').substr(0, 19),
            endtime: this.endtime.replace("T", ' ').substr(0, 19),
            id: this.id
        };
        this.userService.agentUserZbSearch(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.nav.push(AgencyUserZbListPage, {
                    requestData: requestData,
                    data: data
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }
}



// WEBPACK FOOTER //
// ./src/pages/agencyUserZbSearch/agencyUserZbSearch.ts